import { Fragment } from "react";

import { AvatarGroupImage } from "./avatar-group-image";
import { SpotlightTarget } from "./common";
import { Steps } from "./constants/ui";
import { CreateButton } from "./create-button";
import {
    buttonDividerStyle,
    boardHeaderStyle,
    leftButtonGroupStyle,
    rightButtonGroupStyle,
    fadeInRestartButtonStyle,
    wiggleCreateButtonStyle
} from "./jsw-interactive-board.styles";
import { RestartButton } from "./restart-button";
import { useInteractiveBoardStore } from "./state";

export const BoardHeader = () => {
    const [{ isDemoComplete, step }] = useInteractiveBoardStore();
    return (
        <div css={boardHeaderStyle}>
            <div css={leftButtonGroupStyle}>
                <AvatarGroupImage />
                <SpotlightTarget
                    style={
                        step === Steps.CREATE_FIRST_STORY
                            ? wiggleCreateButtonStyle
                            : undefined
                    }
                    name="openIssueModalButton"
                    pulseSize={20}
                    speed="slow"
                >
                    <CreateButton />
                </SpotlightTarget>
            </div>
            <div css={rightButtonGroupStyle}>
                {isDemoComplete && <RestartButton />}
            </div>
        </div>
    );
};
